import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule, Title, provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
// import { DateService } from './services/date.service';
import { DatePipe } from '@angular/common';
import { JwtInterceptor } from './interceptor/jwt.interceptor';
import { CommonService } from './helpers/common.service';
import { NgChartsModule } from 'ng2-charts';
import { IonicStorageModule } from '@ionic/storage-angular';
import { HTTP } from '@awesome-cordova-plugins/http/ngx';
import { Network } from '@awesome-cordova-plugins/network/ngx';
import { CalendarModule } from 'ion2-calendar';
// import { FirebaseX } from '@awesome-cordova-plugins/firebase-x/ngx';
// import { DaterangepickerModule } from 'angular-2-daterangepicker';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
// import { NgSelectModule } from '@ng-select/ng-select';
import { CleverTap } from '@awesome-cordova-plugins/clevertap/ngx';
import { FingerprintAIO } from '@awesome-cordova-plugins/fingerprint-aio/ngx';
import { FileTransfer, FileUploadOptions, FileTransferObject } from '@awesome-cordova-plugins/file-transfer/ngx';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { FileOpener } from '@awesome-cordova-plugins/file-opener/ngx';
import { AppLoaderComponent } from './app-loader/app-loader.component';
import { IonicRouteStrategy, provideIonicAngular, IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { Drivers } from '@ionic/storage';
import { StorageServiceAAA } from './helpers/aaa-storage.service';
import { PayDetailsService } from './pages/pay-details/pay-details.service';
import { TotalClientService } from './components/total-clients/total-clients.service';
import { Appsflyer } from '@awesome-cordova-plugins/appsflyer/ngx';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import {
	ApmModule,
	ApmService,
	ApmErrorHandler,
  } from '@elastic/apm-rum-angular';
  import { ErrorHandler } from '@angular/core';
import { environment } from '../environments/environment';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getRemoteConfig, provideRemoteConfig } from '@angular/fire/remote-config';
@NgModule({
	declarations: [AppComponent, AppLoaderComponent],
	// entryComponents: [],
	imports: [BrowserModule, IonicModule.forRoot({
        mode: 'md',
        scrollAssist: false,
        scrollPadding: false
    }),
        AppRoutingModule, HttpClientModule,
		IonicStorageModule.forRoot(),
		// DaterangepickerModule,
		// CalendarModule,		review
		NgChartsModule,
		IonicStorageModule.forRoot({
            driverOrder: [Drivers.SecureStorage, Drivers.IndexedDB, Drivers.LocalStorage]
        }),
		// NgSelectModule
		BrowserAnimationsModule,
		ApmModule
	],
	providers: [
		Title,
		HttpClientModule,
		HTTP,
		DatePipe,
		Network,
		StorageServiceAAA,
        PayDetailsService,
		CommonService,
		// FirebaseX,
		InAppBrowser,
		FingerprintAIO,
		CleverTap,
		FileTransfer,
		FileTransferObject,
		FileOpener,
		File,
		TotalClientService,
		Appsflyer,
		ApmService,
		{
			provide: ErrorHandler,
			useClass: ApmErrorHandler,
		  },
		{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
		{ provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
		provideFirebaseApp(() => initializeApp(environment.firebaseConfig)) as any,
		provideAuth(() => getAuth()) as any,
		provideFirestore(() => getFirestore()) as any,
		provideRemoteConfig(() => getRemoteConfig()) as any,
		provideAnimations(),
  provideClientHydration(withEventReplay())
	],
	bootstrap: [AppComponent]
})
export class AppModule {
	private appName: any = environment['errorLog'];
	constructor(service: ApmService, private commonService: CommonService) {
		// Configure the APM service
		const apm = service.init({ 
		// const apm = initApm({
		  serviceName: this.appName,
		  serverUrl: `${environment.gatewayBaseUrl}elastic-apm`,
		  serviceVersion: '',
		  environment: environment.production ? 'prod' : 'uat',
		apmRequest: ({ xhr }: { xhr: XMLHttpRequest }) => {
			xhr.setRequestHeader(
			  'Ocp-Apim-Subscription-Key',
			  '2c28da0c4dcb4525987664ae470a1b94'
			);
			xhr.setRequestHeader(
			  'Authorization',
			  this.commonService.get('jwtToken') || '',
			);
			return true;
		  },
		});
	
		apm.addLabels({ Application: this.appName });

		apm.setCustomContext({
		  Application: 'AAA Angular App',
		});
	  
	  // ✅ Add a filter to ignore specific errors dynamically
	apm.addFilter((payload: any) => {
	if (payload && payload.exception && payload.exception.message) {
	  const errorMessage = payload.exception.message;
  
	  // List of ignored errors
	  const ignoredErrors = [              
		'importScripts is not defined',		
		'Uncaught (in promise) Error',	
		'DEPRECATED',
		'Blocked aria-hidden on an element',
		'Cannot set properties of undefined (setting High)',	  
		'POST https://col.site24x7rum.in/rum/wcv 400 (Bad Request)',
		'A listener indicated an asynchronous response by returning true',
		'false.svg 404 (The requested content does not exist.)',
		'\"StatusBar\" plugin is not implemented on web',
		/StatusBar/i,
		/WARNING/i,
		/consent/i,
		/Network/i                          // Ignore any error with "Network"
	  ];
  
	  // Ignore errors that match any string in ignoredErrors
	  if (ignoredErrors.some(err => errorMessage.includes(err))) {
		return null;  // ✅ Ignore this error
	  }
  
	  // Ignore errors matching regex patterns
	  const regexPatterns = [/Network/i];
	  if (regexPatterns.some(pattern => pattern.test(errorMessage))) {
		return null;  // ✅ Ignore this error
	  }
	}
  
	return payload; // ✅ Send other errors to APM
  });
}

 }
